import React from 'react';
import { Link } from 'react-router-dom';

import { portfolioData } from '../mockData';

const Projects = () => {
  const { projects } = portfolioData;

  return (
    <section id="projects">
      <h2 className="label reveal">Projects</h2>
      <div className="entry-list">
        {projects.map((project) => {
          const body = (
            <div className="pub-body">
              <h3 className="entry-title">
                {project.page ? (
                  <Link to={project.page}>{project.title}</Link>
                ) : (
                  project.title
                )}
              </h3>
              <div className="entry-authors">{project.subtitle}</div>
              <div className="entry-venue">{project.technologies.join(' · ')}</div>
              <p className="entry-desc">{project.description}</p>
              <ul className="entry-points">
                {project.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <div className="pub-links">
                {project.github && (
                  <a href={project.github} target="_blank" rel="noopener noreferrer">Code</a>
                )}
                {project.video && (
                  <a href={project.video} target="_blank" rel="noopener noreferrer">Video</a>
                )}
                {project.links?.map((link) => (
                  <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer">{link.label}</a>
                ))}
              </div>
            </div>
          );

          return (
            <div className="entry reveal" key={project.id}>
              <span className="badge">{project.category}</span>
              {project.image ? (
                <div className="pub-with-thumb">
                  <img className="pub-thumb" src={project.image} alt={project.title} loading="lazy" />
                  {body}
                </div>
              ) : (
                body
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;
